<div class='container'>
    <h2 style="text-align: center">{{ call.description }}</h2>
    <div class="form-container" [formGroup]="form">
        @for (inputConfig of inputListConfig; track inputConfig.name) {
            @switch (inputConfig.inputType) {
                @case ('select') {
                    <mat-form-field>
                        <mat-label>{{ inputConfig.label }}</mat-label>
                        <mat-select [formControlName]=" inputConfig.name">
                            @for (option of inputConfig.sourceData; track option[inputConfig?.optionIdPath]) {
                                <mat-option [value]="option">
                                    {{ option[inputConfig?.optionLabelPath] }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                }
                @case ('number') {
                    <mat-form-field>
                        <mat-label>{{ inputConfig.label }}</mat-label>
                        <input
                            matInput
                            [name]="inputConfig.name"
                            [placeholder]="inputConfig.label"
                            [formControlName]="inputConfig.name"
                            type="number"
                        />
                    </mat-form-field>
                }
                @case ('text') {
                    <mat-form-field>
                        <mat-label>{{ inputConfig.label }}</mat-label>
                        <input
                            matInput
                            [name]="inputConfig.name"
                            [placeholder]="inputConfig.label"
                            [formControlName]="inputConfig.name"
                        />
                    </mat-form-field>
                }
                @case ('boolean') {

                    <mat-slide-toggle
                        [name]="inputConfig.name"
                        [formControlName]="inputConfig.name"
                        labelPosition="before"></mat-slide-toggle>

                }
            }
        }
    </div>
    <button (click)="done()" mat-raised-button color="primary" [disabled]="!form.valid">{{ "Next" | translate }}</button>
</div>
